export default [
  {
    text: 'Sturdy pieces, no false fits, and vibrant colours',
    name: 'thepotto',
  },
  {
    text: 'Affordable puzzles with fun images.',
    name: 'Krithvi',
  },
  {
    text: 'They are made from good quality materials',
    name: 'Khozema',
  },
  {
    text: 'The quality of the pieces are really good!',
    name: 'Shruti.',
  },
  {
    text: 'Well designed and very eye catching',
    name: 'Jumana',
  },
  {
    text: 'Great puzzles, great people, great vibe.',
    name: 'Moiz B.',
  },
];
